(() => {
function initialise(scope = document) {
 scope.querySelectorAll('[data-av-catalog]').forEach(catalog => {
  if (catalog.dataset.ready) return; catalog.dataset.ready = 'true';
  const filter = category => {
   let count = 0; const term = (new URLSearchParams(location.search).get('q') || '').toLowerCase().trim();
   catalog.querySelectorAll('[data-category]').forEach(card => {
  const matchesCategory = category === 'all'
    ? card.dataset.favorite === 'true'
    : card.dataset.category === category;

  const title = card.querySelector('.av-card__title').textContent.toLowerCase();
  const matchesSearch = !term || title.includes(term);

  card.hidden = !(matchesCategory && matchesSearch);
  if (!card.hidden) count++;
});
   catalog.querySelector('[data-count]').textContent = count;
   catalog.querySelectorAll('[data-filter]').forEach(button => {const on = button.dataset.filter === category; button.classList.toggle('is-active', on); button.setAttribute('aria-pressed', on);});
  };
  catalog.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
  const category = new URLSearchParams(location.search).get('category');
  filter(['Necklaces','Earrings','Rings','Bracelets'].includes(category) ? category : 'all');
  catalog.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => { const dialog = document.getElementById(button.dataset.open); dialog.showModal(); document.body.style.overflow = 'hidden'; dialog.addEventListener('close', () => {document.body.style.overflow = ''; button.focus();}, {once:true}); }));
  catalog.querySelectorAll('dialog').forEach(dialog => {dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close()); dialog.addEventListener('click', event => {if(event.target === dialog){ const bounds=dialog.getBoundingClientRect(); if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom) dialog.close(); }});});
 });
}
initialise(); document.addEventListener('shopify:section:load', event => initialise(event.target));
})();